import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { AiFillPlusCircle, AiFillMinusCircle, AiFillAccountBook } from 'react-icons/ai';

import Skeleton from "react-loading-skeleton";
import DataTable from "../../../components/Datatable/DataTable";
import Auxiliary from "../../../hoc/Auxiliary/Auxiliary";
import Button from "../../../components/Button/Button";
import DateTimePicker from "../../../components/DateTimePicker/DateTimePicker";

class QNAQuestionListing extends Component {
    /* ============ Component Lifecycle [START] ============ */
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }
    /* ============ Component Lifecycle [END] ============ */

    render() {
        const { t } = this.props;
        let rsListing = [];
        
        /* ======================== datatables data assign [START] ======================== */
        const columns = [
            {
                text: t("event_qna_question.no"),
                dataField: "no",
                formatter: this.props.noFormatter,
                headerStyle: { width: "60px", textAlign: "center" },
            },
            {
                text: t("event_qna_question.date"),
                dataField: "updated_at",
                sort: true,
                onSort: this.props.onSort
            },
            {
                text: t("event_qna_question.en"),
                dataField: "en",
                sort: false,
            },
            {
                text: t("event_qna_question.cn"),
                dataField: "cn",
                sort: false,
            },
            {
                text: t("event_qna_question.ms"),
                dataField: "ms",
                sort: false,
            },
            {
                text: t("event_qna_question.answer"),
                dataField: "answer",
                sort: false,
            },
            {
                text: t("event_qna_question.status"),
                dataField: "status",
                formatter:this.props.statusFormatter,
                sort: false,
            },
            {
                text: t("global.action"),
                dataField: "#",
                formatter: this.props.actionFormatter,
                headerStyle: { width: "100px" },
            },
        ];
        
        if (this.props.data) {
            rsListing = this.props.data.map((val, idx) => {

                let answer = '';
                if (!!(val.answer)) {
                    const answerJSON = JSON.parse(val.answer);
                    Object.keys(answerJSON).map((key) => {
                        if (!!(answer)) {
                            answer = answer + ', ' + t('world_cup.'+answerJSON[key]);                            
                        } else {
                            answer = t('world_cup.'+answerJSON[key]);
                        }
                        return null;
                    });
                }

                return {
                    question_id: val.id,
                    no: idx+1,
                    updated_at: val.updated_at,
                    en: val.en,
                    cn: val.cn,
                    ms: val.ms,
                    answer: answer,
                    status: val.status
                };
            });
        }

        return (
            <Auxiliary>
                <div className="row row-sm">
                    <div className="breadcrumb-header justify-content-between">
                        <div className="my-auto">
                            <div className="d-flex">
                                <h4 className="content-title mb-0 my-auto text-muted mt-1 tx-13 ml-2 mb-0">{t("event_qna_question.qna_question")}</h4>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-12">
                        <div className="card card-body">
                            <div className="col mt-auto">
                                {this.props.loading ? (
                                    <Skeleton count={2} />
                                ) : (
                            <div
                            className={`form-horizontal filter-function row
                            ${this.state.showCard?'open':'close'} filter-wrapper-1`}>
                                <div className="col-md-3 col-6">
                                    <div className="form-group">
                                        <label className="font-weight-bolder">
                                            {t("event_qna_question.date")}
                                        </label>
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">
                                                <i className="fas fa-calendar-check" />
                                            </span>
                                            <DateTimePicker
                                                id="date"
                                                name="date"
                                                className="form-control filter-input"
                                                range={true}
                                                timePicker={true}
                                                value={this.props.filter.date}
                                                onChange={this.props.onInputChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col mt-auto">
                                    <div>
                                    <Button
                                        typeButton="button"
                                        classValue="btn btn-blue"
                                        idValue="filter"
                                        buttonName={t("global.filter")}
                                        clicked={() =>
                                            this.props.refreshHandler()
                                        }
                                    />
                                    &nbsp;
                                    <Button
                                        typeButton="button"
                                        classValue="btn btn-secondary"
                                        idValue="reset"
                                        buttonName={t("global.reset")}
                                        clicked={() =>
                                            this.props.clearHandler()
                                        }
                                    />
                                    </div>
                                </div>

                            </div>
                                    )}
                                </div>

                            <div className="show-btn"
                            onClick={()=>this.toggleCard()}>
                                {
                                    this.state.showCard? <AiFillMinusCircle/> : <AiFillPlusCircle/>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="d-flex align-items-end">
                                <div className="card-header pb-0">
                                    <div className="d-flex justify-content-between">
                                        <h4 className="card-title mg-b-0">
                                            {t("event_qna_question.qna_question_listing")}
                                        </h4>
                                    </div>
                                </div>
                                {this.props.permission.includes("event_qna_question_create") && (
                                    <div className="d-flex">
                                        <div>
                                            <div className="btn-group">
                                                <AiFillPlusCircle />
                                                <Button
                                                    typeButton="button"
                                                    idValue="event_match"
                                                    classValue="btn btn-underline"
                                                    clicked={() => this.props.changePageHandler("create")}
                                                    buttonName={t("event_qna_question.add_question")}
                                                />
                                                &nbsp;&nbsp;&nbsp;
                                                <AiFillAccountBook />
                                                <Button
                                                        typeButton="button"
                                                        classValue="btn btn-underline"
                                                        idValue="payout"
                                                        buttonName={t("event_qna_question.payout")}
                                                        clicked={() =>
                                                            this.props.payoutHandler()
                                                        }
                                                    />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="card-body">
                                <div className="table-responsive table-hover datatable">
                                    <DataTable
                                        keyField="no"
                                        data={rsListing}
                                        columns={columns}
                                        activePage={this.props.activePage}
                                        limit={this.props.limit}
                                        totalItems={this.props.totalRecords}
                                        paginationHandler={(val) =>
                                            this.props.datatablesChangeHandler(
                                                val,
                                                "activePage"
                                            )
                                        }
                                        sizePerPageHandler={(val) =>
                                            this.props.datatablesChangeHandler(
                                                val,
                                                "limit"
                                            )
                                        }
                                        searchChangeHandler={(val) =>
                                            this.props.datatablesChangeHandler(
                                                val,
                                                "searchValue"
                                            )
                                        }
                                        searchValue={this.props.searchValue}
                                        hideSearchBar={true}
                                        classValue="dataTable table-bordered text-justify text-center"
                                        loading={this.props.loading}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

export default withNamespaces("translation")(QNAQuestionListing);
